import React from "react";
import DefaultLayout from "../layouts/Default";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Slider from "../utils/Slider";
import Image from "../utils/Image";
import TitleCar from "../utils/TitleCar";

const images = require.context("../../assets/img/", true);

const MainBanner = () => {
  const sliders = [
    { imageURL: "./banner1.png" },
    { imageURL: "./banner1.png" },
  ];

  return (
    <Slider
      data={sliders.map((item, index) => (
        <Image
          key={index}
          src={images(item.imageURL)}
          alt={`Banner #${index + 1} de la pagina web`}
          classNameDiv="p-0"
          classNameImg="w-100"
        ></Image>
      ))}
      id="slider-banner"
      classItems="w-100"
    />
  );
};

const PresenteProyecto = () => {
  return (
    <DefaultLayout>
      {/* <MainBanner /> */}
      <div className="row justify-content-center ">
        <div className="row col-11 col-lg-9 my-4">
          <div className="col-12 py-3">
            <TitleCar>
              <b>Presente su proyecto</b>
            </TitleCar>
            <div className="pt-5 pb-3 fs-responsive-m">
              <p>
                Con el fin de establecer procedimientos claros en la radicación
                de los diferentes tipos de proyectos de Inversión que desarrolla
                la Corporación a través del Banco de Programas y Proyectos de
                Inversión BPPI-CAR se establecen un serie de pasos y documentos
                de referencia para la radicación de la iniciativa.
              </p>
            </div>

            <Tabs>
              <TabList>
                <Tab>1. PROYECTOS INTERNOS</Tab>
                <Tab>2. PROYECTOS ESTANDARIZADOS</Tab>
                <Tab>3. PROYECTOS DE COFINANCIACION</Tab>
              </TabList>

              <TabPanel>
                <div className="px-3 py-3">
                  <h5>PROYECTOS INTERNOS</h5>
                  <ol className="py-3">
                    <li>
                      Consultar el Plan de Acción PAC vigente para verificar si
                      la iniciativa a presentar se encuentra articulada.
                      (insertar vinculo al PAC)
                    </li>
                    <br />
                    <li>
                      El proyecto formulado deberá contener los documentos
                      requeridos en la lista de chequeo GES-PR-10-FR-10_V2_Lista
                      Verificación de Requisitos, y según apliquen para la
                      iniciativa a presentar. (generar vinculo a la lista de
                      chequeo GES-PR-10-FR-10_V2)
                    </li>
                    <br />
                    <li>
                      Solicitar vía memorando a la Oficina Asesora de Planeación
                      OAP, una mesa de trabajo con los enlaces de cada área
                      técnica, para la revisión y comentarios de la iniciativa a
                      presentar.
                    </li>
                    <br />
                    <li>
                      Una vez cumplidos las observaciones realizadas por la OAP,
                      radicar vía memorando la iniciativa anexando cada uno de
                      los documentos para dar inicio al proceso de inscripción y
                      registro del proyecto.
                    </li>
                    <br />
                  </ol>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="px-3 py-3">
                  <h5>PROYECTOS ESTANDARIZADOS</h5>
                  <ol className="py-3">
                    <li>
                      Consultar en la lista de proyectos estandarizados si la
                      temática de la iniciativa está inscrita y desarrollada.
                    </li>
                    <br />
                    <li>
                      Por tratarse de proyectos cofinanciados deberán cumplir
                      con los lineamientos y requerimientos del Acuerdo 26 de
                      2021 y la resolución 20227000152 del 8 de abril de 2022,
                      igualmente se tendrán que anexar los documentos que le
                      apliquen al proyecto según lista de chequeo
                      GES-PR-10-FR-10_V2.
                    </li>
                    <br />
                    <li>
                      Solicitar vía memorando a la Oficina Asesora de Planeación
                      OAP, una mesa de trabajo para orientar la presentación y
                      contenidos de la iniciativa de proyecto a presentar.
                    </li>
                    <br />
                    <li>
                      Una vez cumplidos las observaciones y directrices
                      aportadas por la OAP, radicar vía memorando y/u oficio la
                      iniciativa anexando cada uno de los documentos para dar
                      inicio al proceso de inscripción y registro del proyecto.
                    </li>
                    <br />
                  </ol>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="px-3 py-3">
                  <h5>PROYECTOS DE COFINANCIACION</h5>
                  <ol className="py-3">
                    <li>
                      Consultar el Plan de Acción PAC vigente para verificar si
                      la iniciativa a presentar se encuentra articulada.
                      (insertar vinculo al PAC)
                    </li>
                    <br />
                    <li>
                      Por tratarse de proyectos cofinanciados deberán cumplir
                      con los lineamientos y requerimientos del Acuerdo 26 de
                      2021 y la resolución 20227000152 del 8 de abril de 2022,
                      igualmente se tendrán que anexar los documentos que le
                      apliquen al proyecto según lista de chequeo
                      GES-PR-10-FR-10_V2.
                    </li>
                    <br />
                    <li>
                      Solicitar vía oficio a la Oficina Asesora de Planeación
                      OAP, una mesa de trabajo para orientar la presentación y
                      contenidos de la iniciativa de proyecto a presentar.
                    </li>
                    <br />
                    <li>
                      Una vez cumplidos las observaciones y directrices
                      aportadas por la OAP, radicar vía oficio la iniciativa
                      anexando cada uno de los documentos para dar inicio al
                      proceso establecido en el Acuerdo 26 de 2021 de
                      Cofinanciación.
                    </li>
                    <br />
                  </ol>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default PresenteProyecto;
